import { TranslationSelector } from '@nai-libs/data-access';
import { TranslateLoader } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  getTranslation(selector: TranslationSelector): Observable<any> {
    return from(import(`libs/shared/data-access/src/lib/translations/${ selector }.json`));
  }
}
